import { render, staticRenderFns } from "./RequisitosMedioambientales.vue?vue&type=template&id=f4eead12&"
import script from "./RequisitosMedioambientales.vue?vue&type=script&lang=js&"
export * from "./RequisitosMedioambientales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports